// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-filter-custom .ant-modal-content .action {
  gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/entities/activities/view/filter/style.scss"],"names":[],"mappings":"AAII;EACE,SAAA;AAHN","sourcesContent":[".modal-filter-custom {\r\n  .ant-modal-content {\r\n    // height: calc(100vh - 115px);;\r\n    // overflow: auto;\r\n    .action {\r\n      gap: 10px;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
